import * as React from "react"

export const linkBackAnchor = () => {
  return (
    <a href="/" className="link link--back">
      <span>Lorem ipsum</span>
      <svg className="link__icon" height="14" width="18">
        <use xlinkHref="#icon--arrow"/>
      </svg>
    </a>
  )
}

export const linkBackButton = () => {
  return (
    <button className="link link--back">
      <span>Lorem ipsum</span>
      <svg className="link__icon" height="14" width="18">
        <use xlinkHref="#icon--arrow"/>
      </svg>
    </button>
  )
}
